<template>
    <div class="animated fadeIn">
      <b-card style="min-height: 300px">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="animated fadeIn">

                <b-row>
                  <b-col cols="auto" class="mr-auto">
                  
                  </b-col>
                  <b-col cols="auto" class="">
                    <b-form-group>
                      <b-button variant="github" class="mr-1 btn-brand" @click="openDocumentModal(null)" v-show="selectedItem.id && selectedItem.id > 0"><i class="fa fa-plus"></i><span>Novo Documento</span></b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
                    
                    
                <b-row>
                  <b-col md="12">
                  
                    <b-table :items="selectedItem.documents" :fields="docFields" :select-mode="docSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left @row-clicked="rowClickedDoc"
    
                    per-page="50" current-page="1" :busy="isBusyDoc" hover striped>
    
                      <template #table-busy>
      
                        <div class="text-center text-danger my-2">
      
                            <b-spinner class="align-middle"></b-spinner>
      
                            <strong>Carregando...</strong>
      
                        </div>
                      </template>
                                    
                      <!-- Example scoped slot for select state illustrative purposes -->
                      <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                          
                                            <span aria-hidden="true">&check;</span>
                          
                                            <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                          <span aria-hidden="true">&nbsp;</span>
                          
                          <span class="sr-only">Not selected</span>
                      </template>
                                    </template>

                      
                      <template v-slot:cell(action)="data">
                        <!--<c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> -->
                        <b-button size="sm" variant="danger" @click="deleteDocument(data.item)" class="mr-1 btn-brand"><i class="fa fa-close"></i></b-button>
                      </template>

                      <template v-slot:cell(st)="data">
                          <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
                      </template>
                                    
                                    
                    </b-table>
                    
                  </b-col>
                </b-row>

              </div>
            </b-form>
          </b-card>

          <b-modal
            v-model="documentModal"
            id="document-modal"
            centered
            hide-footer
            title="Documentos"
            size="lg"
            >
        
        <b-card>   
          <b-form @submit.stop.prevent="onSubmit">
            <div class="animated fadeIn">
              <b-row>
                <b-col md="12">
                  
                  <b-form>
                    <b-form-group
                    description=""
                    label="Tipo de documento"
                    label-for="documentType"
                    :label-cols="3"
                    :horizontal="true">


                    <b-row>
                      <b-col cols="7">
                        <b-form-select id="documentType"
                        v-model="selectedDocument.typeId"
                        :plain="true"
                        :options="documentTypeDDL"
                        value=""
                        :class="typeClass"
                        >
                      </b-form-select>
                      </b-col>

                    </b-row>
                    
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  
                  <b-form>
                    <b-form-group
                    description=""
                    label="Número"
                    label-for="number"
                    :label-cols="3"
                    :horizontal="true">
                      <b-row>
                        <b-col cols="7">
                          <b-form-input v-model="selectedDocument.number" id="number" type="text" :class="numberClass"></b-form-input>
                        </b-col>
                        <b-col cols="2">
                          
                        </b-col>
                        <b-col cols="3">                          
                        </b-col>
                      </b-row>
                  </b-form-group>          
                  </b-form>
                </b-col>
                
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Emissão"
                    label-for="issueDate"
                    :label-cols="3"
                    :horizontal="true">
                    <div>
                      <b-row>
                        <b-col cols="4">
                          <b-form-input v-model="selectedDocument.issueDate" type="date" id="issueDate"></b-form-input>
                        </b-col>
                      </b-row>
                      
                    </div>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Validade"
                    label-for="validity"
                    :label-cols="3"
                    :horizontal="true">
                    <div>
                      <b-row>
                        <b-col cols="4">
                          <b-form-input v-model="selectedDocument.validity" type="date" id="validity"></b-form-input>
                        </b-col>
                      </b-row>
                      
                    </div>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>

              <hr>

              <b-row>
                <b-col md="12">
                  <b-form>
                    <b-form-group
                    description=""
                    label="Aviso de validade"
                    label-for="validityWarning"
                    :label-cols="3"
                    :horizontal="true">
                    <div>
                      <b-row>
                        <b-col cols="4">
                          <b-form-input v-model="selectedDocument.validityWarning" type="date" id="validityWarning"></b-form-input>
                        </b-col>
                      </b-row>
                      
                    </div>
                  </b-form-group>          
                  </b-form>
                </b-col>
              </b-row>


            </div>

            <div slot="footer" class="text-right">
              <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Documento</span></b-button>
          </div>
          
          </b-form>
        </b-card>

       

      </b-modal>

    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
    import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
    //import { table } from 'console'
    
    const toastTypes = {
      success: 'success',
      error: 'error',
      info: 'info',
      warn: 'warn'
    }
    
    miniToastr.init({types: toastTypes})
    
    function toast ({title, message, type, timeout, cb}) {
      return miniToastr[type](message, title, timeout, cb)
    }
    
    const options = {
      success: toast,
      error: toast,
      info: toast,
      warn: toast
    }
    VueNotifications.setPluginOptions(options)
    
    Vue.use(VueNotifications, options)
    /* Toast - End */
  
    export default {
      name: 'PersonDocumentComponent',
      props: {
         item: {}
      },
      computed: {
          selectedItem() {
              return this.item
          }
      },
      components: {
      },
      data: () => {
          return {
            typeClass: '',
            numberClass: '',

            documentModal: false,
            isBusyDoc: false,
            primaryKey: "id",
            documentTypeDDL: [],
            selectedDocument: { number: '', typeId: 0 },
            transProps: {
                // Transition name
                name: 'flip-list'
            },
            docItems: [
              {
                type: "RG",
                number: '282215244',
                issueDate: '02/12/1985',
                validity: '02/12/2015'
              },
              {
                type: "CPF",
                number: '25940525822',
                issueDate: '02/12/1985',
                validity: '02/12/2015'
              }

            ],
            docFields: [
              { key: 'type.name', label: 'Documento', sortable: true },
              { key: 'number', label: 'Número', sortable: true },
              { key: 'issueDate', label: 'Emissão', sortable: true },
              { key: 'validity', label: 'Validade', sortable: true },
              { key: 'validityWarning', label: 'Aviso validade', sortable: true },
              { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
            ],
            docSelectMode: 'single',
          }
      },
      methods: {
        async deleteDocument(item) {
          var s = this
          var currentUser = this.$store.state.currentUser

          await axios.delete(
            this.$store.state.ws_url + "/person/document?id=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.getDocument()
          }).catch(function(error) {
            console.log(error)
          })

        },

        async saveItem() {
          var s = this
          var currentUser = this.$store.state.currentUser

          this.selectedDocument.personId = this.selectedItem.id
          this.selectedDocument.uid = currentUser.id
          this.selectedDocument.sid = currentUser.sid

          await axios.post(
            this.$store.state.ws_url + "/person/document",
            this.selectedDocument
          ).then(function(resp) {
            s.getDocument()
            s.documentModal = false
          }).catch(function(error) {
            console.log(error)
          })

        },
        save() {
          var containsError = false
          if(this.selectedDocument.typeId <= 0) {
            this.typeClass = "is-invalid"
            containsError = true
          }
          else {
            this.typeClass = ""
          }

          if(this.selectedDocument.number.length <= 0) {
            this.numberClass = "is-invalid"
            containsError = true
          }
          else {
            this.numberClass = ""
          }

          if(!containsError) {
            this.saveItem()
          }
        },
        openDocumentModal(item) {
          this.getDocumentType();

          if(item == null) {
            this.selectedDocument.typeId = 0
            this.selectedDocument.number = ""
            this.selectedDocument.validity = null
            this.selectedDocument.issueDate = null
            this.selectedDocument.validityWarning = null
          }
          else {
            this.selectedDocument = item
          }
          this.documentModal = true;
        },


        rowClickedDoc(item) {
          console.log("Editando documento...")
        },
        
        async getDocumentType() {
          var s = this
          var currentUser = this.$store.state.currentUser
          await axios.get(
              this.$store.state.ws_url + "/person/document/type/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
              
          ).then(function(resp) {
            s.documentTypeDDL = resp.data.obj;
          }).catch(function (error) {
            console.log(error);
          })
        },

        async getDocument() {
          var s = this
          var currentUser = this.$store.state.currentUser
          await axios.get(
              this.$store.state.ws_url + "/person/document?personId=" + this.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function(resp) {
            s.selectedItem.documents = resp.data.obj;
          }).catch(function (error) {
            console.log(error);
          })
        }

      },
      mounted: function() {
        this.getDocument()
      }
    }
  
  </script>